import { render, staticRenderFns } from "./HomePopularCities.vue?vue&type=template&id=86df992a&"
import script from "./HomePopularCities.vue?vue&type=script&lang=js&"
export * from "./HomePopularCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports